'use strict';

import * as util from '../util/Common.js';
import {EventManager} from '../util/EventManager.js';
import * as domUtil from '../util/Dom.js';

const privateMap = util.createPrivateMapper();

class AudioResource extends EventManager {
  constructor(info){
    super();
    const pv = privateMap(this);
    // EventManager.implement(this);
    const audio = domUtil.createElement('audio');
    pv.audio = audio;

    pv.audio = audio;
    pv.duration = 0;

    domUtil.setAttr(audio, 'preload', 'metadata');
    domUtil.setAttr(audio, 'type', info.format);

    this.load = function(successCallback, params){
      const canplayHandler = (ev) => {
        domUtil.removeEventListener(audio, 'error', errorHandler);
        domUtil.removeEventListener(audio, 'canplay', canplayHandler);
        domUtil.removeEventListener(audio, 'abort', abortHandler);
        pv.duration = domUtil.getAttr(audio, 'duration');

        successCallback();
        if (params.always) {
          params.always();
        }
      };
      const errorHandler = (ev) => {
        console.log('ERROR');
        domUtil.removeEventListener(audio, 'error', errorHandler);
        domUtil.removeEventListener(audio, 'canplay', canplayHandler);
        domUtil.removeEventListener(audio, 'abort', abortHandler);

        console.log(audio.error);
        if (params.failure) {
          params.failure(ev);
        } else {
          console.error(ev);
        }
        if (params.always) {
          params.always();
        }
      };
      const abortHandler = (ev) => {
        console.log('ABORT');
        if (params.abort) {
          params.abort(ev);
        }
        if (params.always) {
          params.always();
        }
      };
      domUtil.addEventListener(audio, 'error', errorHandler);
      domUtil.addEventListener(audio, 'canplay', canplayHandler);
      domUtil.addEventListener(audio, 'abort', abortHandler);
      domUtil.setAttr(audio, 'src', info['id']);

      return {
        abort: function(){
          audio.src = '';
        }
      }
    };
  }

  get type(){
    return 'audio';
  }

  get duration(){
    return privateMap(this).duration;
  }
  get playbackTarget(){
    return privateMap(this).audio;
  }
};

export class AudioResourceLoader {
  load(source, successCallback, params){
    const resource = new AudioResource(source);
    console.log(resource);
    return resource.load(function(){
      successCallback(resource)
    }, params);
  };
}
